module.exports = __webpack_public_path__ + "img/axt2.fcd2eb7a.png";